import * as yup from "yup";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {

  let defaultSchema: any = getValidationSchema([]);
  
  let customSchema = yup.object().shape({name: yup
    .string()
    .trim("Qualification cannot include leading and trailing spaces")
    .strict(true)
    .min(2, "Qualification must be more than 2 characters")
    .max(150, "Qualification cannot exceed more than 150 characters")
    .matches(
      /^[a-zA-Z0-9].*[a-zA-Z0-9]$/,
      "Qualification cannot start or end with a special character"
    )
    .matches(
      /^[a-zA-Z0-9 .&/-]+$/,
      "Qualification can only contain letters, numbers, spaces, periods, &, hyphens, and slashes"
    )
    .required("Qualification is required"),
    qualificationType: yup.string().required("Qualification Type is a required field"),
  });

  return defaultSchema.concat(customSchema);
};
